module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-regular.74955fcba4d3cb051de3.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.svg
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-regular.svg
// module chunks = styles